<template>
  <v-expansion-panels
    v-model="openPanel"
    class="accordion-drilldown"
    accordion
  >
    <v-expansion-panel
      v-for="(item, itemIndex) in items"
      :key="itemIndex"
      :data-field="itemDataField(itemIndex)"
    >
      <v-expansion-panel-header>
        <BaseEntityBadge
          :initials="item.entity.initials"
          :name="item.entity.name"
          :meta="item.entity.meta"
        />
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <template v-if="Array.isArray(item.tabs)">
          <v-tabs
            :value="getActiveTab(itemIndex)"
            dense
            @change="(value) => setActiveTab(itemIndex, value)"
          >
            <v-tab
              v-for="(tab, tabIndex) in item.tabs"
              :key="tabIndex"
              :data-field="tabDataField(itemIndex, tabIndex)"
            >
              {{ tab.label }}
            </v-tab>
          </v-tabs>
          <v-tabs-items :value="getActiveTab(itemIndex)">
            <v-tab-item
              v-for="(tab, tabIndex) in item.tabs"
              :key="tabIndex"
              :data-field="tabDataField(itemIndex, tabIndex)"
            >
              <div class="accordion-drilldown__tab-content">
                <slot
                  name="tab-content"
                  :item="item"
                  :item-index="itemIndex"
                  :tab="tab"
                  :tab-index="tabIndex"
                />
              </div>
            </v-tab-item>
          </v-tabs-items>
        </template>
        <slot
          v-else
          name="tabs-pending"
          :item="item"
          :item-index="itemIndex"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import BaseEntityBadge from './BaseEntityBadge.vue'
import { sanitizeDataField } from './dataFieldUtils'

const LONG_LIST_WARNING_THRESHOLD = 15

export default {
  name: 'BaseAccordionDrilldown',
  components: { BaseEntityBadge },
  props: {
    items: {
      type: Array,
      required: true
    },
    instance: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      activeTab: {},
      openPanel: undefined
    }
  },
  watch: {
    openPanel(itemIndex) {
      if (itemIndex !== undefined && itemIndex !== null) {
        this.$emit('panel-open', { itemIndex, item: this.items[itemIndex] })
      }
    }
  },
  created() {
    if (process.env.NODE_ENV !== 'production' && this.items.length > LONG_LIST_WARNING_THRESHOLD) {
      // eslint-disable-next-line no-console
      console.warn(
        `BaseAccordionDrilldown: recebeu ${this.items.length} itens (> ${LONG_LIST_WARNING_THRESHOLD}). ` +
        'Listas longas quebram a leitura neste componente — considere usar o BaseDetailDrawer.'
      )
    }
  },
  methods: {
    getActiveTab(itemIndex) {
      return this.activeTab[itemIndex] || 0
    },
    setActiveTab(itemIndex, tabIndex) {
      this.$set(this.activeTab, itemIndex, tabIndex)
    },
    itemDataField(itemIndex) {
      return sanitizeDataField(`${this.instance}-${itemIndex}`)
    },
    tabDataField(itemIndex, tabIndex) {
      return sanitizeDataField(`${this.instance}-${itemIndex}-${tabIndex}`)
    }
  }
}
</script>

<style lang="scss">
.accordion-drilldown {
  &__tab-content {
    padding: 16px 4px 4px;
  }
}
</style>
